/**
 * @fileoverview GET handler for the "/data_objects/:type_name/:external_id/users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameExternalIdUsers } from "./constants";
import type {
  CustomObjectsTypeNameExternalIdUsersParams,
  CustomObjectsTypeNameExternalIdUsersResult,
} from "./types";
import { isCustomObjectsTypeNameExternalIdUsersResult } from "./validators";

export const getDataTableCustomObjectsTypeNameExternalIdUsers = reactQueryTableFetcherAdapter(
  customObjectsTypeNameExternalIdUsers,
  (
    signal: AbortSignal,
    { appGroupId, typeName, externalId, limit = 12, start = 0, user_id }: CustomObjectsTypeNameExternalIdUsersParams
  ): Promise<CustomObjectsTypeNameExternalIdUsersResult> => {
    return fetch(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(externalId)}/users`,
      "GET",
      {
        app_group_id: appGroupId,
        limit,
        start,
        user_id,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isCustomObjectsTypeNameExternalIdUsersResult
);
